<template>
  <div>
    {{ dataIntegrate }}
    <div class="d-flex justify-content-between pb-3">
      <div class="d-flex">
        <ButtonGroupFilter
          :tab.sync="tab"
          class="mr-2"
        />
        <DatePickerFilterRange
          v-if="tab === 0"
          v-model="dateCustom"
          @input="getProportionStatusAllTypeByCustom($event)" />
        <DatePickerFilterMonth
          v-if="tab === 1"
          v-model="dateMonth"
          @input="getProportionStatusAllTypeByMonth($event)" />
        <DatePickerFilterYear
          v-if="tab === 2"
          v-model="dateYear"
          @input="getProportionStatusAllTypeByYear($event)" />
        <DatePickerFilterQuarter
          v-if="tab === 3"
          v-model="dateQuarter"
          @input="getProportionStatusAllTypeByQuarter($event)"
        />
      </div>
    </div>
    <div
      v-show="tab === 0"
      class="d-flex justify-content-center"
    >
      <div
        v-if="dataIntegrate[0] === 0 && dataIntegrate[1] === 0 && dataIntegrate[2] === 0"
        class="no-data-message">
        No data available.
      </div>
      <div
        v-else
        class="d-flex justify-content-center">
        <canvas
          ref="chartCanvas"
          width="420"
          height="420">
        </canvas>
      </div>
    </div>
    <div v-if="tab === 1">
    </div>
    <div v-if="tab === 2">
    </div>
    <div v-if="tab === 3">
    </div>
  </div>
</template>

<script>
import Chart from 'chart.js'
import ButtonGroupFilter from '@/components/ButtonGroupFilter.vue'
import DatePickerFilterRange from '@/components/DatePickerFilterRange.vue'
import DatePickerFilterMonth from '@/components/DatePickerFilterMonth.vue'
import DatePickerFilterYear from '@/components/DatePickerFilterYear.vue'
import DatePickerFilterQuarter from '@/components/DatePickerFilterQuarter.vue'
import ProportionStatusAllTypeProvider from '@/resources/ProportionStatusAllTypesRouterProvider'
import dayjs from 'dayjs'

const ProportionStatusAllTypeService = new ProportionStatusAllTypeProvider()

export default {
  components: {
    ButtonGroupFilter,
    DatePickerFilterMonth,
    DatePickerFilterRange,
    DatePickerFilterYear,
    DatePickerFilterQuarter
  },
  data () {
    return {
      tab: 0,
      value: '',
      formatted: '',
      selected: '',
      dataIntegrate: [],
      dateCustom: [],
      dateMonth: null,
      dateYear: null,
      dateQuarter: [],
      startDateFilter: null,
      endDateFilter: null,
      textIsNoData: '',
      quarter: []
    }
  },
  created () {
    // this.dateCustom = ['2023-07-07T17:00:00.000Z', '2023-08-14T17:00:00.000Z']
    this.getProportionStatusAllTypeByCustom(this.dateCustom)
    // this.renderChart()
  },
  methods: {
    renderChart () {
      const ctx = this.$refs.chartCanvas.getContext('2d')
      const dataOption = this.dataIntegrate
      const total = dataOption.reduce((sum, value) => sum + value, 0)
      const percentages = dataOption.map((value) => ((value / total) * 100).toFixed(0))
      const labelsOption = ['In Progress', 'Closed', 'Cancelled']
      const pieChart = new Chart(ctx, {
        type: 'pie',
        data: {
          labels: labelsOption,
          datasets: [{
            label: 'My First Dataset',
            data: dataOption,
            backgroundColor: [
              '#EC6E85',
              '#6DBEBF',
              '#569FE5'
            ],
            hoverOffset: 4
          }]
        },
        options: {
          responsive: false,
          tooltips: {
            callbacks: {
              label: (tooltipItem, data) => {
                const dataset = data.datasets[tooltipItem.datasetIndex]
                const currentValue = dataset.data[tooltipItem.index]
                const percentage = percentages[tooltipItem.index]
                const label = labelsOption[tooltipItem.index]
                return `${label}: ${currentValue} (${percentage}%)`
              }
            }
          }
        }
      })
      console.log(pieChart)
    },
    onContext (val) {
      this.formatted = val.selectedFormatted
      this.selected = val.selectedYMD
    },
    async getProportionStatusAllTypeByCustom (custom) {
      const startDate = dayjs(custom[0]).format('YYYY-MM-DD')
      const endDate = dayjs(custom[1]).format('YYYY-MM-DD')
      const query = { startDate, endDate }
      const data = await ProportionStatusAllTypeService.findAll(query)
      this.dataIntegrate[0] = data.data.amoutData.inProgress
      this.dataIntegrate[1] = data.data.amoutData.closed
      this.dataIntegrate[2] = data.data.amoutData.void
      await this.renderChart()
    },
    async getProportionStatusAllTypeByMonth (month) {
      const startDate = dayjs(month).startOf('M').format('YYYY-MM-DD')
      const endDate = dayjs(month).endOf('M').format('YYYY-MM-DD')
      const query = { startDate, endDate }
      const data = await ProportionStatusAllTypeService.findAll(query)
      this.dataIntegrate[0] = data.data.amoutData.inProgress
      this.dataIntegrate[1] = data.data.amoutData.closed
      this.dataIntegrate[2] = data.data.amoutData.void
      await this.renderChart()
    },
    async getProportionStatusAllTypeByYear (year) {
      const startDate = dayjs(year).startOf('y').format('YYYY-MM-DD')
      const endDate = dayjs(year).endOf('y').format('YYYY-MM-DD')
      const query = { startDate, endDate }
      const data = await ProportionStatusAllTypeService.findAll(query)
      this.dataIntegrate[0] = data.data.amoutData.inProgress
      this.dataIntegrate[1] = data.data.amoutData.closed
      this.dataIntegrate[2] = data.data.amoutData.void
      await this.renderChart()
    },
    async getProportionStatusAllTypeByQuarter (quarter) {
      if (Array.isArray(quarter) && quarter.length >= 2) {
        const startDate = quarter[0]
        const endDate = quarter[1]
        const query = { startDate, endDate }
        const data = await ProportionStatusAllTypeService.findAll(query)
        this.dataIntegrate[0] = data.data.amoutData.inProgress
        this.dataIntegrate[1] = data.data.amoutData.closed
        this.dataIntegrate[2] = data.data.amoutData.void
        await this.renderChart()
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.no-data-message {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
  font-size: 20px;
  color: #999;
}
</style>
